function initializeSwiper(element) {
  if (!element) return;

  const checkSwiperExists = setInterval(() => {
    const swiperContainer = element.querySelector("[data-recommended-slider]");
    const nextBtn = element.querySelector("[data-recommended-next]");
    const prevBtn = element.querySelector("[data-recommended-prev]");
    const paginationEl = element.querySelector("[data-recommended-pagination]");

    if (!swiperContainer) {
      return;
    }

    clearInterval(checkSwiperExists); // Stop checking once found

    if (typeof Swiper === "undefined") {
      console.error("Swiper library is not loaded.");
      return;
    }

    console.log("Initializing Swiper for", element);

    new Swiper(swiperContainer, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 8,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        580: { slidesPerView: 1, spaceBetween: 8 },
        769: { slidesPerView: 3, spaceBetween: 2 },
        1024: { slidesPerView: 4, spaceBetween: 24 },
      }
    });

    console.log("Swiper initialized successfully.");
  }, 500); // Check every 500ms
}

function observeProductRecommendations() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches("product-recommendations")) {
          console.log("New <product-recommendations> detected:", node);
          initializeSwiper(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Shopify section loading event
document.addEventListener("shopify:section:load", (event) => {
  const productRecs = event.target.querySelector("product-recommendations");
  if (productRecs) {
    initializeSwiper(productRecs);
  }
});

// Run after DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("product-recommendations").forEach(initializeSwiper);
  observeProductRecommendations();
});
